import { include } from "named-urls";

export const routeConfig = {
  dashboard: include("/dashboard", {
    self: "",
    campaign: include("campaign", {
      joinSuccess: "joined",
    }),
    payments: include("payments", {
      self: "",
      orderProcessing: include("order-processing", { self: ":orderId" }),
      cartGroup: include("cart-group", {
        self: ":cartGroupId",
        overview: ":cartGroupId/overview",
        createCartGroup: "new-cart-group",
        editCartGroup: "edit-cart-group/:cartGroupId",
        editSharedCartGroup: include("edit-shared-cart-group/:cartGroupId", {
          clientId: ":clientId",
        }),
        editSharedCartGroupSuccess: "edit-shared-cart-group-success/:cartGroupId",
        shareCartGroup: "share-cart-group/:cartGroupId",
        shareCartGroupSuccess: "share-cart-group-success/:cartGroupId",
        sharedClients: "shared-clients/:cartGroupId",
      }),
      cart: include("cart", {
        self: "",
        cartId: ":cartId",
      }),
      addService: include("add-service", {
        self: "",
        template: include("template", {
          self: ":templateId",
          service: include("service", {
            self: ":serviceId",
            edit: include("edit", {
              self: ":templateId/:serviceId",
            }),
          }),
          providers: include("providers", {
            self: ":providers",
            edit: include("edit", {
              self: ":templateId/:providers",
            }),
          }),
        }),
        recurringPayments: include("recurringPayments", {
          self: "",
          service: include("service", {
            self: ":serviceId",
          }),
          providers: include("providers", {
            self: ":providers",
          }),
        }),
        serviceId: ":serviceId",
      }),
      repeatPayment: include("repeat-payment", {
        self: "",
        serviceId: ":serviceId",
      }),
      paymentOverview: "payment-overview",
      history: include("history", {
        self: "",
        cartGroup: include("cart-group", {
          self: ":cartGroupId",
          filter: ":cartGroupId/filter",
          search: ":cartGroupId/search",
          order: include(":cartGroupId/order", {
            self: ":orderId",
            service: ":orderId/service/:serviceId",
          }),
          summary: include(":cartGroupId/summary", {
            self: ":period",
          }),
          period: include(":cartGroupId/period/", {
            self: ":period",
          }),
        }),
      }),
    }),
    order: include("order", {
      self: "",
      cash: "cash/:orderId",
      mip: "mip/:orderId",
    }),
    services: include("services", {
      self: "",
      fishermanTicket: "fisherman-ticket",
      carInsurance: "car-insurance",
      electricity: "electricity",
      transfers: "transfers",
      category: include("category", {
        self: "",
        categoryId: include(":categoryId", {
          self: "",
          service: include("service", {
            serviceId: ":serviceId",
          }),
        }),
      }),
      prepaidElectricity: "prepaid-electricity-bill",
      charityServices: include("charity-services", {
        self: "",
        charityId: ":charityId",
      }),
      gsmVouchers: include("gsm-vouchers", {
        self: "",
        buyGsmVoucher: include("buy-gsm-voucher", {
          self: "",
          vendor: include(":vendor", {
            self: "",
            serviceId: ":serviceId",
          }),
        }),
        howToUseGsmVoucher: "how-to-use-gsm-voucher",
        gsmTopUpServiceId: ":gsmTopUpServiceId",
        myVouchers: include("my-vouchers", {
          self: "",
          voucherId: ":voucherId",
        }),
      }),
      gsmTopUpServices: include("gsm-top-up-services", {
        self: "",
        gsmTopUpServiceId: ":gsmTopUpServiceId",
      }),
      templates: include("templates", {
        self: "",
        addTemplate: include("add-template", {
          self: "",
        }),
        editTemplate: include("edit-template", {
          self: "",
          templateId: ":templateId",
        }),
      }),
      recurringPayments: include("recurring-payments", {
        self: "",
        editRecurringPayment: include("edit-recurring-payment", {
          self: "",
          recurringPaymentId: ":recurringPaymentId",
        }),
        addRecurringPayment: include("add-recurring-payment", {
          self: "",
        }),
      }),
    }),
    notifications: include("notifications", {
      self: "",
      notification: include("notification", {
        self: "",
        notificationId: ":notificationId",
      }),
    }),
    profile: include("profile", {
      self: "",
      personal: "personal",
      app: "app",
      agreements: "agreements",
      codeChange: "code-change",
      settings: "settings",
      campaign: "campaign",
    }),
    help: include("help", {
      self: "",
      faqGroup: include("faq-group", {
        self: "",
        groupId: ":groupId",
      }),
    }),
    referral: include("/refer-a-friend", {
      self: "",
      referral: "referral",
      coupons: "coupons",
    }),
  }),
  register: include("/register", {
    self: "",
    phoneVerification: "phone-verification",
    smsVerification: "sms-verification",
    createPassword: "create-password",
    registerConfirm: "register-confirm",
  }),
  login: include("/login", {
    self: "",
    loginAs: "login-as",
    password: "password",
    smsVerification: "sms-verification",
    createPassword: "create-password",
    resetPasswordEnterPhone: "reset-password/enter-phone",
    resetPasswordSubmit: "reset-password/submit",
  }),
  referral: "/referral",
  loginAs: "/login-as",
  home: "/",
};
